<script>
import { mapGetters, mapActions } from "vuex";
import i18n from "../i18n";

export default {
  data() {
    return {
      languages: [
        { flag: require("@/assets/images/flags/us.jpg"), language: "en", title: "English" },
        { flag: require("@/assets/images/flags/french.jpg"), language: "fr", title: "French" },
        { flag: require("@/assets/images/flags/spain.jpg"), language: "es", title: "Spanish" },
        { flag: require("@/assets/images/flags/chaina.png"), language: "zh", title: "Chinese" },
        { flag: require("@/assets/images/flags/arabic.png"), language: "ar", title: "Arabic" },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      login: { login_branch: "" },
      multibranch: localStorage.getItem("multibranch"),
    };
  },

  mounted() {
    const val = this.languages.find(x => x.language === i18n.locale);
    if (val) {
      this.text = val.title;
      this.flag = val.flag;
    }
  },

  computed: {
    ...mapGetters("auth", ["name", "email", "branch", "business", "Branches", "branchid"]),
    ...mapGetters("setting", ["GeneralSettings", "BusinessSettings", "App"]),
  },

  methods: {
    ...mapActions({
      LogOut: "auth/logout",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBusinessSettings: "setting/fetchBusinessSettings",
      FetchBraches: "auth/fetchBranches",
      SwitchBranch: "auth/logintoBranch",
    }),
    toggleMenu() { this.$parent.toggleMenu(); },
    switchBranch(id) {
      this.login.login_branch = id;
      this.SwitchBranch(this.login);
    },
    logoutUser() { this.LogOut(); },
    initFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(() => {});
      } else {
        document.exitFullscreen().catch(() => {});
      }
    }
  },

  created() {
    this.FetchGeneralSettings();
    this.FetchBusinessSettings();
    this.FetchBraches();
  },
};
</script>

<template>
<header class="topbar-v2 print-none">

  <!-- LEFT SECTION -->
  <div class="topbar-left">
    <button class="menu-toggle" @click="toggleMenu">
      <i class="bx bx-menu"></i>
    </button>
  </div>

  <!-- CENTER TITLE (Stacked Labels) -->
  <div class="app-title-container">
    <div class="biz-name">{{ business }}</div>
    <div class="branch-name">{{ branch }}</div>
  </div>

  <!-- RIGHT SECTION -->
  <div class="topbar-right">

    <button class="icon-btn d-none d-md-flex" @click="initFullScreen">
      <i class="bx bx-fullscreen"></i>
    </button>

    <!-- DROPDOWN ANCHOR -->
    <div class="user-dropdown-anchor">
      <b-dropdown
        right
        toggle-class="user-toggle"
        menu-class="dropdown-modern"
        no-caret
      >
        <template v-slot:button-content>
          <div class="user-box">
            <div class="user-info d-none d-md-block">
              <div class="name-strong">{{ name || "User" }}</div>
              <div class="role text-end">{{ branch }}</div>
            </div>
            <img src="@/assets/images/users/user1.png" class="avatar" />
            <i class="bx bx-chevron-down"></i>
          </div>
        </template>

        <div v-if="(branchid == 0 || multibranch == 'yes') && Branches && Branches.length">
          <div class="dropdown-title">Switch Branch</div>
          <b-dropdown-item v-for="br in Branches" :key="br.id" @click="switchBranch(br.id)">
            <i class="bx bx-buildings me-2"></i> {{ br.name }}
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
        </div>

        <b-dropdown-item class="logout-item" @click="logoutUser">
          <i class="bx bx-log-out me-2"></i> Logout
        </b-dropdown-item>
      </b-dropdown>
    </div>

  </div>

</header>
</template>

<style>
/* 1. TOPBAR MAIN CONTAINER */
.topbar-v2 {
  position: sticky;
  top: 0;
  z-index: 1050;
  height: 70px; /* Slightly taller for bigger text */
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  overflow: visible !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}

@media print {
  .print-none {
    display: none !important;
  }
}

/* 2. CENTER TITLES (BIG SCREENS) */
.app-title-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
  width: 50%; 
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.biz-name {
  font-weight: 900;
  font-size: 24px; /* Big on Desktop */
  color: #e612e6;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.branch-name {
  font-weight: 600;
  font-size: 15px; /* Big on Desktop */
  color: #6b7280;
  line-height: 1.1;
  margin-top: 2px;
}

/* 3. RIGHT SECTION */
.topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 2;
}

.user-dropdown-anchor {
  position: relative;
}

.user-toggle {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.user-box {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #111827;
  cursor: pointer;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #e612e6;
  object-fit: cover;
}

/* 4. DROPDOWN (DESKTOP) */
.dropdown-modern {
  border-radius: 12px !important;
  border: 1px solid #edf2f7 !important;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15) !important;
  padding: 8px 0 !important;
  margin-top: 12px !important;
  min-width: 220px !important;
}

/* 5. MOBILE & MEDIUM SCREEN ADJUSTMENTS */
@media (max-width: 768px) {
  .biz-name { font-size: 18px; }
  .branch-name { font-size: 13px; }
}

@media (max-width: 576px) {
  .topbar-v2 { height: 65px; padding: 0 10px; }

  /* Medium sizing for small screens */
  .biz-name { font-size: 15px; } 
  .branch-name { font-size: 11px; }

  .app-title-container {
    width: 140px;
  }

  /* Dropdown Mobile Fix */
  .dropdown-modern {
    left: auto !important; 
    right: 0 !important;
    transform: none !important; 
    position: absolute !important;
    min-width: 180px !important;
  }
}

/* 6. MISC ELEMENTS */
.menu-toggle, .icon-btn {
  border: none;
  background: #f1f5f9;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.name-strong { font-size: 14px; font-weight: 700; line-height: 1; }
.role { font-size: 11px; color: #6b7280; }

.dropdown-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #94a3b8;
  padding: 10px 16px 5px;
}

.logout-item a {
  color: #dc2626 !important;
  font-weight: 700;
}

.logout-item a:hover {
  background-color: #fef2f2 !important;
}
</style>